/**
 * トップページ: エリアガイドセクション
 */

/**
 * エリアガイドセクションの初期化
 * @param {jQuery} $ - jQuery
 */
export function initAreas($) {
  const $slide = $('.s-home__areas .s-home__slide');
  const $map = $('.s-home__areas-map');

  if ($slide.length === 0) return;

  // スライド初期化
  $slide
    .on('init', function () {
      // ボタン位置を中央に設定
      $('.s-home__areas .c-slide .slick-prev, .s-home__areas .c-slide .slick-next').css({
        top: '50%',
        transform: 'translateY(-50%)',
      });
    })
    .slick({
      slidesToShow: 1,
      infinite: true,
      arrows: true,
      dots: false,
    });

  // スライド変更時にマップを切り替え
  $slide.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $map.attr('data-area', nextSlide);
  });

  // エリアマップクリック時に対応スライドへ移動
  $map.on('click', '.map-area', function () {
    const areaId = $(this).attr('id');
    if (!areaId) return;

    const areaName = areaId.replace('map-area__', '');

    // 対応するスライドのインデックスを取得
    const $slides = $slide.find('.slick-slide:not(.slick-cloned)');
    let targetIndex = 0;

    $slides.each(function () {
      const $card = $(this).find('.s-home__areas-card');
      if ($card.length && $card.data('area') === areaName) {
        targetIndex = $(this).data('slick-index');
        return false;
      }
    });

    $slide.slick('slickGoTo', targetIndex);
  });
}
